export const eventsData = {
  farm_visit: {
    heading: "Visit Our farmer",
    // eslint-disable-next-line max-len
    content:
      "Enjoy a visit to our farm, understand farming methods, join the farmer, and get your hands dirty. We will organize an interaction with the farmer, followed by breakfast, lunch, or high tea based on your visiting time. All on us, with limited slots available. Register today to secure your spot."
  }
};
